import React from 'react';

import { LinearProgress } from '@mui/material';

import FlightOperationNotificationDataGrid from '../../components/FlightOperationNotificationDataGrid';
import { EventFormStatus, ReportType } from '../../core/api/clients';
import useGetEventReportsByType from '../../core/api/hooks/event-report/useGetEventReportsByType';

interface IFlightOperationNotificationSubmissions {
  hours?: number;
  statuses?: EventFormStatus[];
  isOwner?: boolean;
  pageSize?: number;
  readonly?: boolean;
}

function FlightOperationNotificationList({ hours = 0, statuses = [], isOwner = false, pageSize = 25, readonly = false }: IFlightOperationNotificationSubmissions): JSX.Element {
  const reports = useGetEventReportsByType({
    reportType: ReportType.FlightOperationNotification,
    hours,
    statuses,
    isOwner,
  });
  if (reports?.isLoading) {
    return (
      <LinearProgress />
    );
  }

  return (
    <FlightOperationNotificationDataGrid
      data={reports}
      reportType="flight-operation-notification"
      pageSize={pageSize}
    />
  );
}

export default FlightOperationNotificationList;
